import { ScenarioDef } from '@/services/perfTestsApi';

interface Props {
  scenarios: ScenarioDef[];
  selectedScenario: string;
  selectedProfile: string;
  selectedTarget: string;
  allowedTargets: string[];
  profileDurationsSec?: Record<string, number>;
  onScenarioChange: (name: string) => void;
  onProfileChange: (profile: string) => void;
  onTargetChange: (target: string) => void;
  disabled?: boolean;
}

function fmtDuration(sec: number): string {
  if (sec < 60) return `${sec} s`;
  if (sec < 3600) return `${Math.round(sec / 60)} min`;
  const h = Math.floor(sec / 3600);
  const m = Math.round((sec % 3600) / 60);
  return m > 0 ? `${h} h ${m} min` : `${h} h`;
}

export function ScenarioPicker({
  scenarios,
  selectedScenario,
  selectedProfile,
  selectedTarget,
  allowedTargets,
  profileDurationsSec,
  onScenarioChange,
  onProfileChange,
  onTargetChange,
  disabled,
}: Props) {
  const current = scenarios.find((s) => s.name === selectedScenario);
  const allowedProfiles = current?.allowedProfiles ?? [];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">Scénario</label>
        <select
          className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm bg-white disabled:bg-gray-100"
          value={selectedScenario}
          onChange={(e) => onScenarioChange(e.target.value)}
          disabled={disabled}
        >
          {scenarios.map((s) => (
            <option key={s.name} value={s.name}>
              {s.name} — {s.description}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">Profil</label>
        <select
          className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm bg-white disabled:bg-gray-100"
          value={selectedProfile}
          onChange={(e) => onProfileChange(e.target.value)}
          disabled={disabled || allowedProfiles.length === 0}
        >
          {allowedProfiles.map((p) => {
            const sec = profileDurationsSec?.[p];
            const label = sec ? `${p} (${fmtDuration(sec)})` : p;
            return (
              <option key={p} value={p}>{label}</option>
            );
          })}
        </select>
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">Cible</label>
        <select
          className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm bg-white disabled:bg-gray-100"
          value={selectedTarget}
          onChange={(e) => onTargetChange(e.target.value)}
          disabled={disabled}
        >
          {allowedTargets.map((t) => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
      </div>
    </div>
  );
}
